<template>
  <v-application v-if="access.employee_total_worked">
    <v-layout row class="ma-2">
      <v-flex class="px-2 mt-2" md3 xs6>
        <v-datetime-picker
          v-model="options.start_date"
          solo
          label="Start date"
          :max="options.end_date"
        />
      </v-flex>
      <v-flex class="px-2 mt-2" md3 xs6>
        <v-datetime-picker
          v-model="options.end_date"
          solo
          label="End date"
          v-bind:min="options.start_date"
        />
      </v-flex>

      <v-flex class="px-2 mt-2" md2 xs4>
        <v-combobox
          v-model="store"
          v-bind:items="stores"
          item-text="name"
          solo
          dense
          prepend-inner-icon="mdi-store"
        />
      </v-flex>
      <v-flex class="px-2 mt-2" md2 xs4>
        <v-combobox
          item-text="name"
          solo
          dense
          v-model="options.employee"
          v-bind:items="employees"
          prepend-inner-icon="mdi-account"
        />
      </v-flex>
    </v-layout>

    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          v-model="page"
          :numPages="num_pages"
          name="timeworked"
          add
          v-bind:headers="headers"
          v-bind:data="data"
          no-delete
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:getData="update"
          TotalHours
        >
          <template #search>
            <v-spacer />
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                :autofocus="search_field"
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), searchTotalHours();
                  }
                "
                @change="searchTotalHours()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <v-btn icon @click="downloadTotalHoursWorkedExcel">
              <v-icon> mdi-download </v-icon>
            </v-btn>
            <v-dialog v-model="proccessDialog" max-width="400px">
              <v-card>
                <v-list-item-action style="width: 338px; padding-left: 40px">
                  <v-progress-linear
                    :color="
                      excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'
                    "
                    background-color="white"
                    height="10"
                    style="border: 1px solid rgba(0, 0, 0, 0.26)"
                    v-bind:value="excel_dowload_proccess"
                    striped
                  />
                  <v-list-item-action-text
                    >{{ $t("download") }}
                    {{ excel_dowload_proccess.toFixed() + " %" }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-card>
            </v-dialog>
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import fileSaver from "file-saver";
import xlsx from "xlsx";
var now = new Date();
export default {
  name: "EmployeesTimeworks",
  mixins: [Services],
  data: () => ({
    options: {
      start_date: new Date(new Date().setDate(now.getDate() - 7))
        .toISOString()
        .substr(0, 10),
      end_date: new Date(new Date().setDate(now.getDate() + 1))
        .toISOString()
        .substr(0, 10),
      custom: false,
      employee: null,
    },
    store: null,
    params: null,
    times: [],
    employees: [{ name: "All employees", _id: "" }],
    headers: [
      {
        text: "Employee",
        value: "employee_name",
        available: true,
        disabled: true,
      },
      { text: "Store", value: "stores", available: true },
      { text: "Total minutes", value: "minutes", available: true },
      { text: "Total work time", value: "total_work_time", available: true },
    ],
    data: [],
    page: 1,
    num_pages: 0,
    data_loading: true,
    proccessDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
    search: "",
    search_field: false,
    search_text: false,
  }),
  methods: {
    async downloadTotalHoursWorkedExcel() {
      this.proccessDialog = true;
      this.excel_dowload_proccess = 0;

      const start_date = new Date(this.options.start_date);
      const end_date = new Date(this.options.end_date);
      this.loading = true;
      const limit = 500;
      let all_data = [];
      const page_count = Math.ceil(this.max_total / limit);

      for (let page = 1; page <= page_count; page++) {
        const response = this.$communicator.then(
          this,
          await this.$communicator("worked_hours", {
            arguments: [
              start_date.getTime(),
              end_date.getTime() + (86400000 - 1),
              limit,
              page,
            ],
            params: {
              services: this.store._id != "" ? [this.store._id] : [],
              employees:
                this.options.employee?._id != ""
                  ? [this.options.employee?._id]
                  : [],
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...response?.data);
      }
      this.proccessDialog = false;
      this.loading = true;
      const result = all_data.map((total) => {
        total.minutes = Number(total.minutes.toFixed())
        const hours = parseInt(total.minutes / 60)
        const minutes = total.minutes - parseInt(total.minutes / 60) * 60
        return {
          Employee: total.employee_name,
          Tin: total.tin,
          Store: total.stores.toString(),
          "Worked minutes": total.minutes,
          "Worked hours": `${hours}: ${minutes}`,
        }
      });
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "TotalHourWorked.xlsx");
    },
    changePagination(page) {
      this.page = page;
      this.update();
    },
    async update_reports() {
      const employees = this.$communicator.then(
        this,
        await this.$communicator("all_employees", {
          params: {
            service: this.store._id,
          },
        })
      );
      if (employees) {
        this.employees = [
          { name: "All employees", _id: "" },
          ...this.$copy(employees),
        ];
        var is = true;
        if (this.options.employee !== null) {
          for (const index in this.employees) {
            if (this.options.employee._id == this.employees[index]._id)
              is = false;
          }
        }
        if (is) this.options.employee = this.$copy(this.employees[0]);
        if (this.update) {
          this.update({ service: this.store._id, ...this.options });
        }
      }
    },
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    searchTotalHours() {
      this.update();
    },
    async update() {
      this.data_loading = true;
      const start_date = new Date(this.options.start_date);
      const end_date = new Date(this.options.end_date);
      const reports = this.$communicator.then(
        this,
        await this.$communicator("worked_hours", {
          arguments: [
            start_date.getTime(),
            end_date.getTime() + (86400000 - 1),
            10,
            this.page,
          ],
          params: {
            services: this.store._id != "" ? [this.store._id] : [],
            employees:
              this.options.employee?._id != ""
                ? [this.options.employee?._id]
                : [],
            search: this.search,
          },
        })
      );
      if (reports) {
        this.max_total = reports?.total;
        this.num_pages = reports.page;
        for (let i = 0; i < reports.data.length; i++) {
          let time = new Date(reports.data[i].time);
          reports.data[i].time =
            time.getDate() +
            "/" +
            (time.getMonth() + 1) +
            "/" +
            time.getFullYear();

            reports.data[i].minutes = Number(reports.data[i].minutes.toFixed())
            const hours = parseInt(reports.data[i].minutes / 60)
            const minutes = reports.data[i].minutes - parseInt(reports.data[i].minutes / 60) * 60
            reports.data[i].total_work_time = `${hours}: ${minutes} minutes`
        }
        reports.data.push({
          employee_name: this.$t("total"),
          hours: reports.total_hours,
        });
        this.data = reports.data;
      }
      this.data_loading = false;
    },
  },
  mounted() {
    this.headers = [
      {
        text: this.$t("employee"),
        value: "employee_name",
        available: true,
        disabled: true,
      },
      { text: this.$t("store"), value: "stores", available: true },
      { text: "Total minutes", value: "minutes", available: true },
      { text: "Total work time", value: "total_work_time", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  watch: {
    "options.start_date": {
      handler() {
        this.update_reports();
      },
    },
    "options.end_date": {
      handler() {
        this.update_reports();
      },
    },
    "options.custom": {
      handler() {
        this.update_reports();
      },
    },
    "options.employee._id": {
      handler() {
        this.update_reports();
      },
    },
    "store._id": {
      handler() {
        this.$store.commit("setItemsService", this.store);
        this.update_reports();
      },
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
  },
};
</script>
